import { Tooltip } from "antd";
import { Info } from "@phosphor-icons/react";
import { BottomCard as Card, BottomCardHeader2 } from "./styles";

export const BottomCardGraphic3 = ({
  label,
  helpText,
  children
}) => {

  return (
    <Card style={{ gap: ".5rem" }}>
      <BottomCardHeader2>
        <span>{label}</span>

        <Tooltip title={helpText}>
          <Info size="1rem" color="#EC6643" />
        </Tooltip>
      </BottomCardHeader2>

      {children}
    </Card>
  );
};